import Vue from 'vue'
import Router from 'vue-router'
import Bookshelves from './views/bookshelves.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/Book/F/',
    routes: [{
        path: '/index.html',
        name: 'Bookshelves',
        component: Bookshelves,
        meta: {
            title: '霄鸟云玩具配件配套 行业专业DM杂志',
        }
    }, {
        path: '/periodical.html',
        name: 'Periodical',
        component: () => import('./views/periodical.vue'),
        meta: {
            title: '书刊',
        }
    }]
});
